import React, { useEffect, useState } from 'react'
import { Button, Flex, Input, Select } from 'antd'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { createLead, obtainLegal } from 'src/api/graphql'

import { Platforms } from 'src/interfaces/types/app'

import { WspIcon } from './icon'
import FileUpload from '../FileUpload'

import { WhatsappContainer } from './styles'

import { isValidDniOrRuc } from './utils'

import config from '../../config/app'

import './styles.css'

const wsp_endpoint = `https://api.whatsapp.com`
const cellNumber = config.web.cellNumber?.replace(/([\+\ \&])/g, '')
const message = 'Hola, me gustaría solicitar una cotización rápida.'

const { TextArea } = Input

interface IForm {
  ruc: string
  company: string
  address: string
  place: string | undefined
  obs: string
  fileUrl: string
}

const initialValues: IForm = {
  ruc: '',
  company: '',
  address: '',
  place: undefined,
  obs: '',
  fileUrl: '',
}

const validationSchema = yup.object().shape({
  ruc: yup
    .string()
    .required('¡Este campo es requerido!')
    .test('is-dni-or-ruc', 'Debe ser un RUC o DNI válido', (value) =>
      value ? isValidDniOrRuc(value) : false
    ),
  company: yup.string().optional(),
  address: yup.string().optional(),
  place: yup.string().required('¡Este campo es requerido!'),
  obs: yup.string().required('¡Este campo es requerido!'),
  fileUrl: yup.string().optional(),
})

const WhatsappEquip: React.FC = () => {
  const [isShow, setShow] = useState<boolean>(false)
  const [ruc, setRUC] = useState<string>('')
  const [loadInfoLegal, infoLegal, loading] = obtainLegal({ input: { ruc } })
  const [create, { loading: loadingLead }] = createLead()
  const formik = useFormik<IForm>({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const input = {
        ruc: values.ruc,
        company: values.company,
        obs: values.obs,
        place: values.place,
        fileUrl: values.fileUrl,
        flow: 'wssp-floating',
        origin: 'store',
      }
      create({
        context: { clientName: Platforms.accounts },
        variables: { input },
      })
        .then((_: any) => {
          /*console.log('--res--')
          console.log(res)*/
        })
        .catch((_: any) => {
          /*console.log('-er-roro')
          console.log(err)*/
        })

      let text: string = 'Hola'
      if (values.company) {
        text += `, soy *${values.company}*`
      }
      if (values.ruc) {
        text += `, mi RUC es *${values.ruc}*`
      }
      if (values.obs) {
        text += `.\nQuiero cotizar esta lista: ${values.obs}`
      }
      if (values.place) {
        text += `.\n*Ubicación:* ${values.place}`
      }
      if (values.fileUrl) {
        text += `.\n*Lista Adjunta:* ${values.fileUrl}`
      }
      const redirectTo = `${wsp_endpoint}/send?phone=${cellNumber}&text=${encodeURIComponent(text)}`
      formik.resetForm()
      setShow(false)
      window.open(redirectTo, '_blank')
    },
  })

  const form = (
    <div
      style={{
        backgroundImage: 'url(/images/bg-whatsapp.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: 320,
        height:
          470 +
          10 * 2 * (formik.touched.ruc && Boolean(formik.errors.ruc) ? 1 : 0) +
          10 * 2 * (formik.touched.place && Boolean(formik.errors.place) ? 1 : 0) +
          10 * 2 * (formik.touched.obs && Boolean(formik.errors.obs) ? 1 : 0),
        position: 'absolute',
        bottom: 76,
        right: 20,
        zIndex: 20,
        borderRadius: 12,
      }}
    >
      <Flex
        vertical
        gap={20}
        justify="flex-end"
        align="center"
        style={{ width: 280, height: '100%', margin: 'auto', paddingBottom: 20 }}
      >
        <Flex vertical gap={4} style={{ width: '100%' }}>
          <Input
            className="custom-placeholder"
            name="ruc"
            placeholder="RUC o DNI"
            size="small"
            value={formik.values.ruc}
            required
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            style={
              formik.touched.ruc && formik.errors.ruc
                ? {
                    borderRadius: 25,
                    fontSize: 12,
                    paddingInline: 14,
                    paddingBlock: 8,
                    borderColor: 'red',
                    borderWidth: 2,
                  }
                : { borderRadius: 25, fontSize: 12, paddingInline: 14, paddingBlock: 8 }
            }
          />
          {formik.touched.ruc && formik.errors.ruc && (
            <span style={{ color: 'red', fontSize: 12, paddingLeft: 4 }}>{formik.errors.ruc}</span>
          )}
        </Flex>

        <Flex vertical gap={4} style={{ width: '100%' }}>
          <Flex
            style={
              formik.touched.place && formik.errors.place
                ? {
                    borderRadius: 25,
                    fontSize: 12,
                    paddingInline: 10,
                    paddingBlock: 8,
                    backgroundColor: 'white',
                    width: '100%',
                    borderColor: 'red',
                    borderWidth: 2,
                  }
                : {
                    borderRadius: 25,
                    fontSize: 12,
                    paddingInline: 10,
                    paddingBlock: 8,
                    backgroundColor: 'white',
                    width: '100%',
                  }
            }
          >
            <Select
              placeholder="Seleccionar Ubicación"
              size="small"
              className="select-small custom-placeholder"
              value={formik.values.place}
              options={[
                { value: 'lima', label: <span style={{ fontSize: 12 }}>Lima</span> },
                { value: 'province', label: <span style={{ fontSize: 12 }}>Provincias</span> },
              ]}
              onBlur={() => formik.setFieldTouched('place', true)}
              onChange={(val: string) => {
                formik.setFieldValue('place', val)
                formik.setFieldTouched('place', true)
              }}
              style={{ width: '100%', fontSize: 12 }}
              variant="borderless"
            />
          </Flex>
          {formik.touched.place && formik.errors.place && (
            <span style={{ color: 'red', fontSize: 12, paddingLeft: 4 }}>
              {formik.errors.place}
            </span>
          )}
        </Flex>

        <Flex vertical gap={4} style={{ width: '100%' }}>
          <TextArea
            name="obs"
            placeholder="Escribe aquí tu lista de materiales..."
            size="small"
            value={formik.values.obs}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="custom-placeholder"
            style={
              formik.touched.obs && formik.errors.obs
                ? {
                    borderRadius: 25,
                    fontSize: 12,
                    paddingInline: 14,
                    paddingBlock: 8,
                    height: 100,
                    borderColor: 'red',
                    borderWidth: 2,
                  }
                : {
                    borderRadius: 25,
                    fontSize: 12,
                    paddingInline: 14,
                    paddingBlock: 8,
                    height: 100,
                  }
            }
          />
          {formik.touched.obs && formik.errors.obs && (
            <span style={{ color: 'red', fontSize: 12, paddingLeft: 4 }}>{formik.errors.obs}</span>
          )}
        </Flex>

        <FileUpload onFileUpload={formik.handleChange('fileUrl')} />

        <Flex vertical gap={14} justify="center" align="center">
          <Button
            type="link"
            onClick={() => formik.handleSubmit()}
            disabled={loading || loadingLead || !formik.isValid}
          >
            <img src="/images/btn-whatsapp.png" style={{ width: 200 }} />
          </Button>
          <span style={{ fontSize: 12, fontWeight: 400, color: 'white' }}>
            o llámanos al {config.web.cellNumber}
          </span>
        </Flex>
      </Flex>
    </div>
  )

  useEffect(() => {
    if (infoLegal) {
      formik.setFieldValue('company', infoLegal.businessName)
      formik.setFieldValue('address', infoLegal.businessLocation?.address)
    }
  }, [infoLegal.businessName])

  useEffect(() => {
    if (isValidDniOrRuc(formik.values.ruc)) {
      setRUC(formik.values.ruc)
      loadInfoLegal()
    }
  }, [formik.values.ruc])

  return (
    <WhatsappContainer>
      <a className="wrapper" target="_blank" rel="noreferrer">
        <div
          onClick={() => setShow(!isShow)}
          className="click-btn-whatsapp"
          style={{
            marginRight: 18,
            height: 58,
            paddingLeft: 20,
            paddingRight: 20,
            background: '#ffbe2e',
            borderRadius: 9,
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontStyle: 'normal',
            fontWeight: 800,
            fontSize: 16,
            letterSpacing: 2.26347,
            textTransform: 'uppercase',
            color: '#0d2769',
            position: 'relative',
          }}
        >
          Cotización rápida
          <div
            className="decor"
            style={{
              position: 'absolute',
              height: 23,
              width: 8,
              background: '#ffbe2e',
              right: -7,
              clipPath: 'polygon(0 0, 0% 100%, 100% 50%)',
            }}
          ></div>
        </div>
        <div
          onClick={() => setShow(!isShow)}
          className="click-btn-whatsapp"
          style={{
            width: 60,
            height: 60,
            boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
            padding: 12,
            backgroundColor: '#fff',
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '50%',
            alignItems: 'center',
          }}
        >
          <WspIcon width={88} height={88} />
        </div>

        {isShow && form}
      </a>
    </WhatsappContainer>
  )
}

export default WhatsappEquip
